import { render, staticRenderFns } from "./PriceModelDetail.vue?vue&type=template&id=3271caaa&scoped=true"
import script from "./PriceModelDetail.vue?vue&type=script&lang=js"
export * from "./PriceModelDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceModelDetail.vue?vue&type=style&index=0&id=3271caaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271caaa",
  null
  
)

export default component.exports